import React from 'react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { Icon, IconChoices } from '../../../common/Icon'
import { cn } from '../../../../helpers/utils'

interface MessageBarUploadProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  uploadDisabled: boolean
  onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const MessageBarUploadDocuments = <T extends FieldValues>({
  control,
  name,
  uploadDisabled,
  onUpload,
}: MessageBarUploadProps<T>): JSX.Element => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onUpload(e)
  }

  return (
    <Controller
      control={control}
      name={name}
      render={() => (
        <label
          htmlFor="chat-document-input"
          className={cn(
            uploadDisabled
              ? 'pointer-events-none cursor-not-allowed opacity-50'
              : 'hover:bg-gray-light',
            'flex p-2 max-h-[44px] self-end'
          )}
        >
          <Icon icon={IconChoices.DOCUMENT} size={26} />
          <input
            id="chat-document-input"
            type="file"
            // add document accepts
            className="w-0 max-w-0 opacity-0"
            tabIndex={0}
            multiple
            disabled={uploadDisabled}
            onChange={onChange}
          />
        </label>
      )}
    />
  )
}
